import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import '@fortawesome/fontawesome-free/css/all.css';

Vue.use(Vuetify);

export default new Vuetify({
  icons: {
    iconfont: 'mdi' // default - only for display purposes
  },
  theme: {
    options: {
      customProperties: true
    },
    themes: {
      light: {
        primary: '#BA4438',
        secondary: '#514648', // '#4f3f40'
        accent: '#8c9eff',
        error: '#b71c1c',
        hovergrey: '#fafafa',
        lightgrey: '#eeeeee',
        brightgrey: '#f6f6f6',
        brownie: '#4f3f40',
        mastard: '#f3a055',
        matcha: '#758f39',
        bloody: '#ba4438'
      }
    }
  }
});
